import React from 'react';

/**
 * Create a ref that will always contain the latest value
 * @param value The initial value of the ref
 */
export default function useLatest<T>(value: T): React.MutableRefObject<T> {
  const ref = React.useRef(value);
  React.useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
